var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 62,
    viewBox: "0 0 58 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1669 5.49996H54.5002C55.2517 5.49996 55.9723 5.79847 56.5037 6.32982C57.035 6.86118 57.3336 7.58185 57.3336 8.33329V53.6666C57.3336 54.4181 57.035 55.1387 56.5037 55.6701C55.9723 56.2015 55.2517 56.5 54.5002 56.5H43.1669V5.49996ZM3.10073 5.15146L38.7157 0.0656252C38.9167 0.0367914 39.1216 0.0515031 39.3164 0.108763C39.5112 0.166023 39.6914 0.264493 39.8449 0.3975C39.9983 0.530507 40.1213 0.694943 40.2056 0.879663C40.29 1.06438 40.3336 1.26507 40.3336 1.46813V60.5318C40.3335 60.7346 40.29 60.935 40.2058 61.1195C40.1217 61.304 39.9989 61.4683 39.8458 61.6012C39.6927 61.7342 39.5128 61.8327 39.3183 61.8902C39.1239 61.9476 38.9193 61.9627 38.7186 61.9343L3.0979 56.8485C2.42248 56.7523 1.80446 56.4156 1.35735 55.9003C0.910237 55.385 0.664069 54.7257 0.664062 54.0435V7.95646C0.664069 7.27423 0.910237 6.61491 1.35735 6.09962C1.80446 5.58432 2.42248 5.24765 3.0979 5.15146H3.10073ZM26.1669 19.6666V33.8021L20.5002 28.1666L14.8619 33.8333L14.8336 19.6666H9.16689V42.3333H14.8336L20.5002 36.6666L26.1669 42.3333H31.8336V19.6666H26.1669Z",
    fill: "#4AB6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/wordIcon.f2bd41c7356793ab6d2d70b3c15c14c5.svg";
export { ForwardRef as ReactComponent };